import keys from "lodash/keys";
import forOwn from "lodash/forOwn";
import every from "lodash/every";
import isArray from "lodash/isArray";

import * as Validations from "./validations";

export const EXCEL_MAXIMUM_CELL_LENGTH = 32767;
export const MAXIMUM_STRING_LENGTH = 255;
export const MINIMUM_PASSWORD_LENGTH = 10;

class FormValidator {
  constructor(schema, fields) {
    this.schema = schema;
    this.fields = fields;
    this.errors = {};
  }

  validate() {
    // Clear all errors
    this.errors = {};

    const fieldsValid = keys(this.schema).map(fieldName => this.validateField(fieldName));

    return every(fieldsValid);
  }

  validateField(fieldName) {
    // Clear errors for the field.
    this.errors[fieldName] = [];

    const schemaField = this.schema[fieldName];

    // If no schema field and validations were set, we admit that the record
    // is valid.
    if (!schemaField || !schemaField.validations) {
      return true;
    }

    const value = this.fields[fieldName];

    forOwn(schemaField.validations, (params, validationName) => {
      // Allow passing false / null to the validation params to disable
      // the validation. Useful for validations that are managed from the
      // admin panel.
      if (!params) {
        return;
      }

      const validate = Validations[validationName];

      if (!validate) {
        throw new Error(
          `Missing validation for : ${validationName}. The error occured ` +
            `while trying to validate the following field : ${fieldName}.`
        );
      }

      // Provide the whole context to the validations so validations that
      // depend on other fields (like password confirmation matching) can
      // inspect other fields.
      const errors = validate(value, params, fieldName, this.fields, this.schema);

      // Store generated errors on the field.
      this.addErrors(errors);
    });

    return this.errors[fieldName].length === 0;
  }

  addErrors(fieldErrors) {
    forOwn(fieldErrors, (errors, fieldName) => {
      this.addError(fieldName, errors);
    });
  }

  addError(fieldName, errorMessages) {
    if (!isArray(errorMessages)) {
      errorMessages = [errorMessages];
    }

    // When errors are from a child model we ignore the error path
    fieldName = fieldName.split(".").pop();

    // If the backend returns errors for a field that's not present in the front form,
    // we ignore them.
    if (!this.errors[fieldName]) return;

    this.errors[fieldName] = [...this.errors[fieldName], ...errorMessages];
  }

  // Adds server generated errors to formValue fields and returns the updated
  // formValue to be updated in the source component.
  //
  pushErrors(errors) {
    errors.forEach(({ field: fieldName, messages }) => {
      this.addError(fieldName, messages);
    });
  }
}

export default FormValidator;
